export default __webpack_public_path__ + "static/media/scipy.f0f9f132.svg";